import {get} from 'lodash';

export const getPersonAvatarUrl = (item: any) => get(item, 'avatarUrl', '');

export const getPersonFullName = (item: any) =>
  `${get(item, 'firstName', '')}` + ` ${get(item, 'lastName', '')}`;

export const isCoach = (item: any) => {
  const custometTypeId = get(item, 'customerTypeId', 1);
  if (custometTypeId === 1) {
    return true;
  }
  return false;
};

export const getGeneration = (item: any) => get(item, 'generation', 0);

export const getPersonId = (item: any) =>
  get(
    item,
    'id',
    `${get(item, 'firstName', '')}` + `${get(item, 'lastName', '')}`,
  );
